import { DateTime } from "luxon";

export function formatTimelineForecastMarker(
  allFrameTimes: { time: number }[],
  timezone: string,
  language: string
) {
  const markers: { index: number; label: string }[] = [];
  const seenDays = new Set<string>();

  for (let i = 0; i < allFrameTimes.length; i++) {
    const timestamp = allFrameTimes[i]?.time;
    if (!timestamp) continue;

    const currentTime = DateTime.fromSeconds(timestamp, {
      zone: timezone,
    }).setLocale(language);

    const dayKey = currentTime.toFormat("yyyy-MM-dd");

    if (i === 0) {
      const label = currentTime.toFormat("ccc dd");
      markers.push({ index: i, label });
      seenDays.add(dayKey);
      continue;
    }

    if (!seenDays.has(dayKey)) {
      seenDays.add(dayKey);
      const label =
        markers.length < 2
          ? currentTime.toFormat("ccc dd")
          : currentTime.toFormat("dd/LL");

      markers.push({ index: i, label });
    }
  }

  return markers;
}
